export default {

  umaMedia: 'media@ultimatemedical.edu',

}
